import React, { useState } from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/contactus_background.jpg";
import { useNavigate } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";

const ContactUsPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClick = () => {
    navigate("/login");
  };

  // - Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // - Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Gọi hàm axiosReqConfig (url, method, data)
    const result = await axiosReqConfig(
      `${API_IP}/api/contact-us`,
      "post",
      formData,
    );

    setIsSubmitting(false);

    // axiosReqConfig thường trả về data nếu thành công, hoặc in lỗi ra console
    if (result && result !== undefined) {
      alert("Thank you! Your message has been sent.");
      setFormData({ name: "", email: "", message: "" }); // Reset form
    } else {
      // Trường hợp lỗi, axiosReqConfig trong file của bạn đã log lỗi rồi
      // Nhưng ta có thể báo thêm cho người dùng biết
      alert("Failed to send message. Please try again later.");
    }
  };

  const onBookNowHandle = () => {
    navigate("/consultation");
  };

  return (
    <div>
      <div
        className="homeHeaderContainer"
        style={{
          backgroundImage: `url(${BackgroundImage})`,
          width: "100vw",
          height: "70vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div>
          <h1 className="homeTitleText">Contact Us</h1>
        </div>
      </div>
      <div className="homeBodyContainer">
        <div className="ContactUsTitleContainer">
          <h1>Contact Us</h1>
          <p>
            We’re here to help. Get in touch, ask questions, or book a free
            in-home or virtual consultation with our care team.
          </p>
        </div>
        <div className="ContactUsBodyContainer">
          <div className="CUInfoContainer">
            <h3>iCare Village – Head Office</h3>
            <p>Email: info@icaresolutions.ca</p>
            <p>Phone: +1 (250) 507 4262</p>
            <p>Mailing address:</p>
            <p>4088 interurban rd, Victoria, BC, V8Z4W7</p>
          </div>
          <div className="CUMethodsContainer">
            {/* <div className="CUMethodsOption">
              <img
                className="CUTempLogo"
                src={require("../images/coming_soon.png")}
              />
              <h5>Coming Soon</h5>
            </div> */}
            <div className="CUMethodsOption">
              <img
                className="CUMethodsLogo"
                src={require("../images/book_consultation_icon.png")}
              />
              <h4>Book A Free In-Home/Virtual Consultation</h4>
              <p>
                We’re here to support you. Book a complimentary, no-obligation
                in-home or virtual consultation with a member of our care team.
              </p>
              <p>
                During this conversation, we take time to understand your needs,
                preferences, and goals, and explain how iCare Village provides
                compassionate, non-medical home care services. Together, we’ll
                explore how we can support you or your loved one safely and
                comfortably at home.
              </p>
              <button
                className="ContactUsSubmitButton"
                onClick={onBookNowHandle}
              >
                Book a Free Consultation
              </button>
            </div>
            <div
              className="CUMethodsOption"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/platform-orientation")}
            >
              <img
                className="CUMethodsLogo"
                src={require("../images/book_consultation_icon.png")}
                style={{ filter: "hue-rotate(45deg)" }} // Đổi màu icon một chút để phân biệt
              />
              <h4>Free iCare Village Platform Orientation</h4>
              <p>
                A free session to help you understand and use the iCare Village
                platform. Need help booking? We are here to guide you.
              </p>
              <button className="ContactUsSubmitButton">
                Request Orientation
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* New Contact Form Section */}
      <div className="ContactUsFormContainer">
        <h2>Send us a message — we’re here to help</h2>
        <form onSubmit={handleSubmit}>
          <div className="ContactUsFormGroup">
            <label>Your full name</label>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="ContactUsFormGroup">
            <label>Your email address</label>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="ContactUsFormGroup">
            <label>
              Tell us a little about how we can help — for you or your loved
              one.
            </label>
            <textarea
              name="message"
              rows="5"
              placeholder="How can we help you?"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button
            type="submit"
            className="ContactUsSubmitButton"
            disabled={isSubmitting}
            style={{ opacity: isSubmitting ? 0.7 : 1 }}
          >
            {isSubmitting ? "Sending..." : "Send Message to Care Team"}
          </button>
          <p className="ContactUSNoteText">
            A real person from our care team will get back to you within one
            business day.
          </p>
        </form>
      </div>
    </div>
  );
};

export default ContactUsPage;
